module.exports = __webpack_public_path__ + "static/media/CHED1 .feda4073.png";